<!-- Inline: no own dialog, for hosts that are one (stacked dialogs closed each other).
     The header is repeated because its directives need the enclosing dialog. -->
@if (inline) {
  <!-- Escape cancels the crop, not the host dialog. -->
  <div class="grid gap-4" (keydown.escape)="$event.stopPropagation(); onCancel()">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>Bild zuschneiden</h3>
      <p hlmDialogDescription>
        Wähle den gewünschten Bildausschnitt.
        @if (cropDescription) {
          {{ cropDescription }}
        } @else {
          {{
            roundCropper
              ? 'Das Bild wird kreisförmig zugeschnitten.'
              : 'Das Bild wird quadratisch zugeschnitten.'
          }}
        }
      </p>
    </div>
    <ng-container *ngTemplateOutlet="content" />
  </div>
} @else {
  <hlm-dialog [state]="open ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
    <hlm-dialog-content *hlmDialogPortal class="max-h-[90vh] max-w-3xl overflow-y-auto">
      <div hlmDialogHeader>
        <h3 hlmDialogTitle>Bild zuschneiden</h3>
        <p hlmDialogDescription>
          Wähle den gewünschten Bildausschnitt.
          @if (cropDescription) {
            {{ cropDescription }}
          } @else {
            {{
              roundCropper
                ? 'Das Bild wird kreisförmig zugeschnitten.'
                : 'Das Bild wird quadratisch zugeschnitten.'
            }}
          }
        </p>
      </div>
      <ng-container *ngTemplateOutlet="content" />
    </hlm-dialog-content>
  </hlm-dialog>
}

<ng-template #content>
  <div class="bg-muted flex min-h-64 items-center justify-center rounded-lg p-2 sm:p-4">
    @if (loadError) {
      <div class="flex flex-col items-center gap-2 px-4 py-12 text-center">
        <p hlmLarge>Bild konnte nicht geladen werden</p>
        <p hlmMuted class="text-sm">
          Das Format wird von deinem Browser nicht unterstützt. Versuche es mit einem JPG- oder
          PNG-Bild.
        </p>
      </div>
    } @else if (imageFile) {
      <!-- The File goes in directly: converting it to base64 first doubled a
           phone photo in memory and dropped the EXIF orientation handling. -->
      <image-cropper
        class="app-image-cropper size-full"
        [imageFile]="imageFile"
        [maintainAspectRatio]="true"
        [aspectRatio]="aspectRatio"
        [resizeToWidth]="resizeToWidth"
        [cropperMinWidth]="80"
        [roundCropper]="roundCropper"
        [canvasRotation]="canvasRotation"
        [transform]="transform"
        [alignImage]="'center'"
        [backgroundColor]="'transparent'"
        format="jpeg"
        (imageCropped)="imageCropped($event)"
        (cropperReady)="cropperReady()"
        (loadImageFailed)="loadImageFailed()"></image-cropper>
    } @else {
      <div class="flex flex-col items-center gap-3 py-12">
        <hlm-spinner class="text-[length:--spacing(8)]" />
        <p hlmMuted class="text-sm">Bild wird geladen…</p>
      </div>
    }
  </div>

  @if (!loadError) {
    <div class="flex flex-wrap items-center gap-2">
      <button hlmBtn variant="outline" size="sm" [disabled]="!ready" (click)="zoomIn()">
        <ng-icon name="lucideZoomIn" />
        <span class="hidden sm:inline">Vergrößern</span>
      </button>
      <button hlmBtn variant="outline" size="sm" [disabled]="!ready" (click)="zoomOut()">
        <ng-icon name="lucideZoomOut" />
        <span class="hidden sm:inline">Verkleinern</span>
      </button>
      <button hlmBtn variant="outline" size="sm" [disabled]="!ready" (click)="rotateLeft()">
        <ng-icon name="lucideRotateCcw" />
        <span class="hidden sm:inline">Links drehen</span>
      </button>
      <button hlmBtn variant="outline" size="sm" [disabled]="!ready" (click)="rotateRight()">
        <ng-icon name="lucideRotateCw" />
        <span class="hidden sm:inline">Rechts drehen</span>
      </button>

      <button
        hlmBtn
        variant="ghost"
        size="sm"
        class="ms-auto"
        [disabled]="!ready"
        (click)="resetTransform()">
        Zurücksetzen
      </button>
    </div>
  }

  <div hlmDialogFooter>
    <button hlmBtn variant="outline" (click)="onCancel()">
      {{ loadError ? 'Schließen' : 'Abbrechen' }}
    </button>
    @if (!loadError) {
      <button hlmBtn [disabled]="!canSave" (click)="onSave()">Übernehmen</button>
    }
  </div>
</ng-template>
